import Matching from './Matching.esm.js';
import scoring from './scoring/index.esm.js';
import TimeEstimates from './TimeEstimates.esm.js';
import Feedback from './Feedback.esm.js';
export { default as ZxcvbnOptions } from './Options.esm.js';

const time = () => new Date().getTime();

const createReturnValue = (resolvedMatches, password, start) => {
  const feedback = new Feedback();
  const timeEstimates = new TimeEstimates();
  const matchSequence = scoring.mostGuessableMatchSequence(password, resolvedMatches);
  const calcTime = time() - start;
  const attackTimes = timeEstimates.estimateAttackTimes(matchSequence.guesses);
  return {
    calcTime,
    ...matchSequence,
    ...attackTimes,
    feedback: feedback.getFeedback(attackTimes.score, matchSequence.sequence)
  };
};

const zxcvbn = password => {
  const matching = new Matching();
  const start = time();
  const matches = matching.match(password);

  if (matches instanceof Promise) {
    return matches.then(resolvedMatches => {
      return createReturnValue(resolvedMatches, password, start);
    });
  }

  return createReturnValue(matches, password, start);
};

export { zxcvbn };
//# sourceMappingURL=index.esm.js.map
